var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5 mt-5"},[_c('md-empty-state',{staticClass:"md-accent",attrs:{"md-rounded":"","md-icon":"remove_circle","md-label":"Acceso denegado","md-description":"Tu usuario no dispone de los permisos requeridos para el acceso."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }